import { ApplicationState } from '@app/store'
import {
  ICurrentUserState,
  selectCurrentUser,
} from '@app/store/modules/account'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { createStructuredSelector } from 'reselect'
import TeamViewPage from '../components/TeamViewPage'
import {
  actionCreators,
  ITeamViewState,
  selectError,
  selectIsLoading,
  selectItem,
  selectPermissions,
  selectShowConfirmDelete,
} from '../modules/teamView'

export default withRouter(
  connect(
    createStructuredSelector<
      ApplicationState,
      ITeamViewState & ICurrentUserState
    >({
      error: selectError(),
      isLoading: selectIsLoading(),
      item: selectItem(),
      permissions: selectPermissions(),
      showConfirmDelete: selectShowConfirmDelete(),
      user: selectCurrentUser(),
    }),
    actionCreators,
  )(TeamViewPage),
)
